
import { init, captureMessage } from "@sentry/browser";

export const initialiseSentry = () => {
    init({
        dsn: "https://98e2779a151d4bcb994055e81f334c6d@sentry.io/1336441",
        release: import.meta.env.VITE_SENTRY_RELEASE
    });
};

export const reportErrorToSentry = (tag: string, errorMessage: string) => {
    captureMessage(
        errorMessage,
        {
            operation: tag,
            level: "error"
        }
    );
}
